<template>
    <v-container fluid class="incidente-root">
        <div>
            <h2>Unidades</h2>
            <v-card class="pa-3 mb-3 filtros-card" outlined>
                <v-row align="center" dense>
                    <!-- BUSCADOR -->
                    <v-col cols="12" md="4" class="d-flex align-center">
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar por titulo" outlined dense clearable hide-details class="mb-0" />
                    </v-col>
                    <!-- ARCHIVO -->
                    <v-col cols="12" md="3" class="d-flex align-center">
                        <v-file-input v-model="archivoImportar" label="Archivo Excel" accept=".xlsx,.xls" outlined dense hide-details prepend-icon="mdi-file-excel" class="mb-0" />
                    </v-col>
                    <!-- BOTONES -->
                    <v-col cols="12" md="5" class="d-flex align-center justify-end">
                        <v-btn color="#e4b510" dark class="mr-2" :loading="importando" :disabled="!archivoImportar || importando" @click="importarExcel">
                            <v-icon left small>mdi-microsoft-excel</v-icon> Importar XLSX
                        </v-btn>
                        <v-btn outlined color="#5e672c" @click="descargarPlantilla">
                            <v-icon left small>mdi-download</v-icon> Plantilla
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <!-- <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar por titulo" outlined dense></v-text-field> -->
            <v-divider class="mx-4" inset vertical></v-divider>  

            <!-- Diálogo para crear un nueva -->
            <v-dialog v-model="dialog" max-width="70%">
                <template v-slot:activator="{ on }">
                    <v-btn class="perfil-btn-primary" dark v-on="on" @click="nueva">Registrar</v-btn>
                </template>
                <v-card class="admin-form-card">
                    <v-card-title>
                        <v-icon left color="#f7c325">mdi-database-cog-outline</v-icon>
                        <span class="text-h5">{{ formTitle }}</span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="dialog = false"> <v-icon>mdi-close</v-icon> </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form" v-model="formValid" lazy-validation>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field v-model="dato.nombre" label="Titulo" :rules="[rules.required]" clearable/>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-text-field v-model="dato.codigo" label="Código" :rules="[rules.required]" clearable/>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-text-field v-model="dato.porc" label="% Bonificación" type="number" clearable/>
                                        </v-col>
                                        <v-col cols="12" md="12">
                                            <v-text-field v-model="dato.descripcion" label="Descripción" clearable/>
                                        </v-col>
                                    </v-row>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="perfil-btn-outline" outlined @click="dialog=false" :disabled="dialog_guardando"> Cancelar </v-btn>
                        <v-btn :loading="dialog_guardando" :disabled="!formValid || dialog_guardando" class="perfil-btn-primary" @click="guardar" >
                            {{ isNew ? 'Guardar' : 'Actualizar' }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-data-table :headers="headers" :items="filtered" item-key="oid" :items-per-page="30">
                <template v-slot:item.activo="{ item }">
                    <v-chip small dark :color="item.activo ? 'green' : 'red'">
                        {{ item.activo ? 'Activo' : 'Inactivo' }}
                    </v-chip>
                </template>
                <template v-slot:item.fecha="{ item }">
                    {{ new Date(item.fecha).toLocaleString() }}
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon small class="mr-2" v-on="on" @click="mostrar(item.oid)">mdi-eye</v-icon>
                        </template>
                        <span>Detalle</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="item.tipo != 2">
                        <template v-slot:activator="{ on }">
                            <v-icon small class="mr-2" v-on="on" @click="editar(item)">mdi-pencil</v-icon>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="item.tipo != 2">
                        <!-- <template v-slot:activator="{ on }">
                            <v-icon small class="mr-2" color="red" v-on="on" @click="confirmarEliminar(item.oid)">mdi-delete</v-icon>
                        </template>
                        <span>Eliminar</span> -->
                        <template v-slot:activator="{ on }">
                            <v-icon small class="mr-2" :color="item.activo ? 'red' : 'green'" v-on="on" @click="confirmarCambiarEstado(item)">
                                {{ item.activo ? 'mdi-close-circle' : 'mdi-check-circle' }}
                            </v-icon>
                        </template>
                        <span>{{ item.activo ? 'Inactivar' : 'Activar' }}</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        
            <!-- Formulario de creación/edición -->      
            <v-form ref="form" @submit.prevent="guardar">
            </v-form>

            <!-- Diálogo para ver detalle-->
            <v-dialog v-model="dialogdetail" max-width="70%">
                <v-card>
                <v-card-title>
                    <span>{{ formTitle }}</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogdetail = false"> <v-icon>mdi-close</v-icon> </v-btn>
                </v-card-title> 
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-row>
                                <v-col cols="12">
                                    <h3 class="text-center" style="color: #e4b510;">Información General</h3>
                                </v-col>
                                <v-col cols="12" md="8">
                                    <strong>Titulo:</strong><br>{{ dato.nombre }}
                                </v-col>
                                <v-col cols="12" md="2">
                                    <strong>Código:</strong><br>{{ dato.codigo }}
                                </v-col>
                                <v-col cols="12" md="2">
                                    <strong>% Bonificación:</strong><br>{{ dato.porc }}
                                </v-col>
                                <v-col cols="12" md="3">
                                    <strong>Fecha Registro:</strong><br>{{ new Date(dato.fecha).toLocaleString() }}
                                </v-col>
                                <v-col cols="12" md="3">
                                    <strong>Usuario Creador:</strong><br>{{ getUserN(dato.oid_user) }}
                                </v-col>
                                <v-col cols="12" md="8">
                                    <strong>Descripción:</strong><br>{{ dato.descripcion }}
                                </v-col>
                            </v-row>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="secondary" text @click="dialogdetail = false;">Cerrar</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Diálogo de confirmación para eliminar -->
            <v-dialog v-model="showConfirmDialog" max-width="500px">
                <v-card>
                <v-card-title class="headline">Confirmar eliminación</v-card-title>
                <v-card-text>
                    ¿Estás seguro de que deseas eliminar este registro?
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" text @click="eliminar(confirmItemId)">Sí</v-btn>
                    <v-btn color="secondary" text @click="cancelarEliminar">No</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="showConfirmDialogEstado" max-width="500px">
                <v-card>
                    <v-card-title class="headline">
                        {{ itemEstado && itemEstado.activo ? 'Confirmar inactivación' : 'Confirmar activación' }}
                    </v-card-title>
                    <v-card-text>
                        ¿Estás seguro de que deseas
                        <strong>{{ itemEstado && itemEstado.activo ? 'inactivar' : 'activar' }}</strong>
                        este registro?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" text @click="cancelarCambioEstado"> Cancelar </v-btn>
                        <v-btn :color="itemEstado && itemEstado.activo ? 'red' : 'green'" dark :loading="dialog_guardando" @click="cambiarEstado">
                            {{ itemEstado && itemEstado.activo ? 'Inactivar' : 'Activar' }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Dialogo para Mensaje cargando-->
            <v-dialog v-model="dialog_guardando" max-width="550px"> 
                <v-card>
                    <v-card-title class="headline">Guardando .....</v-card-title>
                </v-card>
            </v-dialog>
            
            <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="5000" top>
                {{ snackbarMensaje }}
                <template v-slot:action="{ attrs }">
                    <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
                </template>
            </v-snackbar>

            <v-dialog v-model="importando" persistent max-width="420">
                <v-card class="text-center pa-6">
                    <v-progress-circular indeterminate color="#5e672c" size="64" width="6" class="mb-4" />
                    <div class="text-h6 font-weight-bold mb-2" style="color:#384018;">
                        Importando archivo
                    </div>
                    <div class="grey--text text--darken-1">
                        Por favor espera, se están cargando los datos del Excel.
                    </div>
                </v-card>
            </v-dialog>

        </div>
    </v-container>
</template>
  
<script>
import axios from 'axios';
import { setUsers, getUserN } from '@/utils/validators';
import { utils, writeFileXLSX } from 'xlsx';
  
export default {
    data() {
        return {
            datos: [],
            dato: {
                oid: 0,
                nombre: '',
                descripcion: '',
                activo: true,
                tipo: null,
                codigo: '',
                porc: null,
                oid_user: null,
                fecha: null,
            },
            isNew: true,
            dialog: false, // Controla la visibilidad del diálogo
            formTitle: '', // Título del diálogo
            dialogdetail: false,
            showConfirmDialog: false, showConfirmDialogEstado: false, itemEstado: null,
            confirmItemId: null,
            search: '', // Valor del campo de búsqueda
            dialog_guardando: false,
            snackbar: false,
            snackbarMensaje: '',
            snackbarColor: 'error',
            rules: {
                required: v => v !== null && v !== undefined && v !== '' || 'Requerido',
                maxValue: max => v =>
                    (!v || Number(v) <= max) || `El valor no puede ser mayor a ${max}`,
                select: v => (v !== null && v !== undefined && v !== '') || 'Selecciona una opción',
            },
            formValid: false,
            archivoImportar: null,
            importando: false,
        };
    },
    computed: {
        headers() {
            const baseHeaders = [
                { text: 'Acciones', value: 'actions', sortable: false },
                { text: 'Titulo', value: 'nombre' },
                { text: 'Código', value: 'codigo' },
                { text: 'Estado', value: 'activo' },
                // { text: '%', value: 'porc' },
                // { text: 'Descripción', value: 'descripcion' },
                { text: 'Usuario Creador', value: 'user' },
                { text: 'Fecha Registro', value: 'fecha' },
            ];

            return baseHeaders;
        },
        filtered() {
            // Filtrar por el valor de búsqueda
            return this.datos.filter(dato =>
                dato.nombre.toLowerCase().includes(this.search.toLowerCase())
            );
        },
        userName() {
            const user = localStorage.getItem('userName'); 
            return user;
        },
        rolOid() {
            const tipo = localStorage.getItem('rolu');
            return Number(tipo);
        },    
        userOid() {
            const oid_user = localStorage.getItem('oidu');
            return Number(oid_user);
        },
    },
    mounted() {
        this.listar();
    },
    methods: {
        // Obtener la lista
        async listar() {
            try {
                //await setUnidads();
                await setUsers();

                const response = await axios.get('api/Unidads/Listar');
                this.datos = response.data.map(h => ({
                    ...h,
                    user: getUserN(h.oid_user)
                }));
            } catch (error) {
                console.error(error);
            }
        },
        // Mostrar detalles
        async mostrar(id) {
            try {
                const response = await axios.get(`api/Unidads/Mostrar/${id}`);
                this.dato = response.data;
                this.isNew = false;
                this.formTitle = 'Detalle Unidad';
                this.dialogdetail = true;
            } catch (error) {
                console.error(error);
            }
        },
        // Abrir el diálogo para crear una nuevo
        nueva() {
            this.dato = { 
                oid: 0,
                nombre: '',
                descripcion: '',
                activo: true,
                tipo: null,
                codigo: '',
                porc: null,
                oid_user: null,
                fecha: null,
            };
            this.isNew = true;
            this.formTitle = 'Crear Unidad';
            this.dialog = true;
            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.resetValidation();
                this.formValid= false;
            });
        },
        // Abrir el diálogo para actualizar
        editar(dato) {
            this.dato = { ...dato };
            this.isNew = false;
            this.formTitle = 'Actualizar Unidad';
            this.dialog = true;
        },
        // Guardar creada o actualizada
        async guardar() {
            // VALIDACION
            const ok = this.$refs.form && this.$refs.form.validate();
            if (!ok) return;

            this.dialog_guardando = true;
            this.dato.oid_user = this.userOid;
            try {        
                if (this.isNew) {
                    // Crear el área
                    const respuestaCrear = await axios.post('api/Unidads/Crear', this.dato);
                } else {
                    // Actualizar el área
                    await axios.put(`api/Unidads/Actualizar`, this.dato);
                }

                // Reset del formulario
                if (this.$refs.form) {
                    this.$refs.form.reset();
                    this.$refs.form.resetValidation();
                }

                // Limpiar el formulario después de guardar o actualizar
                this.dato = { 
                    oid: 0,
                    nombre: '',
                    descripcion: '',
                    activo: true,
                    tipo: null,
                    codigo: '',
                    porc: null,
                    oid_user: null,
                    fecha: null,
                };

                // Después de guardar exitosamente el registro:
                this.dialog = false;
                await this.listar();
                
                this.snackbarMensaje = "Registro guardado correctamente";
                this.snackbarColor = "success";
                this.snackbar = true;
            }catch(error) {
                console.error(error);
                this.snackbarMensaje = "Error al guardar registro.";
                this.snackbarColor = "error";
                this.snackbar = true;
            } finally {
                // Independientemente de si la solicitud tuvo éxito o no, detenemos el Unidad de carga.
                this.dialog_guardando = false;
            }
        },
        // Eliminar
        async eliminar(id) {
            try {
                await axios.delete(`api/Unidads/Eliminar/${id}`);
                this.listar();
                this.cancelarEliminar();
            } catch (error) {
                console.error(error);
            }
        },
        // Confirmar eliminación
        confirmarEliminar(id) {
            this.confirmItemId = id;
            this.showConfirmDialog = true;
        },
        // Cancelar eliminación
        cancelarEliminar() {
            this.confirmItemId = null;
            this.showConfirmDialog = false;
        },
        getUserN,
        confirmarCambiarEstado(item) {
            this.itemEstado = { ...item };
            this.showConfirmDialogEstado = true;
        },
        cancelarCambioEstado() {
            this.itemEstado = null;
            this.showConfirmDialogEstado = false;
        },
        async cambiarEstado() {
            if (!this.itemEstado) return;

            this.dialog_guardando = true;

            try {
                const payload = {
                    ...this.itemEstado,
                    activo: !this.itemEstado.activo
                };

                await axios.put(`api/Unidads/Actualizar`, payload);

                this.showConfirmDialogEstado = false;
                this.itemEstado = null;

                await this.listar();

                this.snackbarMensaje = payload.activo
                    ? "Registro activado correctamente"
                    : "Registro inactivado correctamente";

                this.snackbarColor = "success";
                this.snackbar = true;

            } catch (error) {
                console.error(error);
                this.snackbarMensaje = "Error al cambiar el estado del registro.";
                this.snackbarColor = "error";
                this.snackbar = true;
            } finally {
                this.dialog_guardando = false;
            }
        },
        async importarExcel() {
            if (!this.archivoImportar) return;

            this.importando = true;

            try {
                const formData = new FormData();
                formData.append('archivo', this.archivoImportar);
                formData.append('oid_user', this.userOid);

                const response = await axios.post(
                    'api/Unidads/ImportarExcel',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );

                const data = response.data;

                this.snackbarMensaje =
                    `Importación finalizada. Insertados: ${data.insertados || 0}. ` +
                    `Duplicados: ${data.duplicados?.length || 0}. ` +
                    `Errores: ${data.errores?.length || 0}.`;

                this.snackbarColor = 'success';
                this.snackbar = true;

                this.archivoImportar = null;
                await this.listar();

            } catch (error) {
                console.error(error);

                this.snackbarMensaje =
                    error.response?.data?.message ||
                    'Error al importar el archivo Excel.';

                this.snackbarColor = 'error';
                this.snackbar = true;

            } finally {
                this.importando = false;
            }
        },
        descargarPlantilla() {

            const datos = [
                {
                    Nombre: 'UNIDAD EJEMPLO 1',
                    Código: '00001',
                    Descripción: 'Descripción opcional',
                    Activo: 1,
                    Tipo: '',
                    Porcentaje: 0
                },
                {
                    Nombre: 'UNIDAD EJEMPLO 2',
                    Código: '00002',
                    Descripción: '',
                    Activo: 1,
                    Tipo: '',
                    Porcentaje: 0
                }
            ];

            const ws = utils.json_to_sheet(datos);

            const wb = utils.book_new();

            utils.book_append_sheet(wb, ws, 'Datos');

            writeFileXLSX(wb, 'Plantilla_Catalogos.xlsx');
        }
    },
};
</script> 
<style>
    p {
        font-family: 'Gotham', !important;
    }
    h1 {
        font-family: 'Gotham', !important;
    }

    .incidente-root {
        padding-top: 0 !important;
        margin-top: 0 !important;
        width: 100% !important;
        align-self: flex-start !important;
        margin-left: 1%;
    }
</style>

